// Faza 4: Lokacijske landing stranice (SR primary, EN/RU prevodi).
// Cilj — "near me" pretrage iz okolnih kvartova Novog Beograda i Beograda.
// Sav sadržaj je opšteg karaktera, lokalno orijentisan ka klinici PHYSIOWRLD
// (Omladinskih brigada 96E/4, Novi Beograd).

export interface LocationFAQ {
  question: string;
  answer: string;
}

export interface LocationI18n {
  h1: string;
  metaTitle: string;
  metaDesc: string;
  intro: string;
  /** 2-4 rečenice — zašto je klinika pogodna baš za stanovnike ovog kvarta */
  whyHere: string[];
  /** Konkretna uputstva — pešice / autom / autobusom */
  directions: { mode: string; description: string }[];
  /** Tipične usluge koje tražе klijenti iz tog kvarta */
  popularServices: string[];
  /** Lokalni landmark-i / orijentiri u radijusu pretrage */
  nearby: string[];
  faqs: LocationFAQ[];
}

export interface Location {
  slug: string;
  /** Naziv kvarta / lokacije */
  name: { sr: string; en: string; ru: string };
  /** Procenjena vazdušna udaljenost od klinike (km) — za schema */
  distanceKm: number;
  /** Procenjeno vreme pešačenja u minutima */
  walkMinutes: number;
  /** Procenjeno vreme vožnje u minutima */
  driveMinutes: number;
  /** Lokalni servisi koje preporučujemo (interno linkovanje ka /services...) */
  relatedServices: { path: string; label: { sr: string; en: string; ru: string } }[];
  /** Slugovi povezanih dijagnoza iz src/data/diagnoses.ts — interno linkovanje za topical authority */
  relatedDiagnoses: string[];
  i18n: { sr: LocationI18n; en: LocationI18n; ru: LocationI18n };
}

export const LOCATIONS: Location[] = [
  // 1. BLOK 64
  {
    slug: 'fizikalna-terapija-blok-64',
    name: { sr: 'Blok 64', en: 'Block 64', ru: 'Блок 64' },
    distanceKm: 0.6,
    walkMinutes: 8,
    driveMinutes: 3,
    relatedDiagnoses: [
      'diskus-hernija-tretman-beograd',
      'bol-u-ledjima-tretman-beograd',
      'bol-u-vratu-tretman-beograd',
      'teniski-lakat-tretman-beograd',
      'bol-u-ramenu-tretman-beograd',
      'bol-u-kolenu-tretman-beograd',
    ],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/shockwave-terapija-novi-beograd', label: { sr: 'Shockwave terapija', en: 'Shockwave therapy', ru: 'Ударно-волновая терапия' } },
      { path: '/laser-terapija-novi-beograd', label: { sr: 'Laser terapija', en: 'Laser therapy', ru: 'Лазеротерапия' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Blok 64, Novi Beograd',
        metaTitle: 'Fizikalna terapija Blok 64 — PHYSIOWRLD klinika | Novi Beograd',
        metaDesc: 'Fizikalna terapija i rehabilitacija za stanovnike Bloka 64. Klinika PHYSIOWRLD je u Omladinskih brigada 96E/4, 8 minuta pešice. Pozovite +381 60 503 7477.',
        intro: 'PHYSIOWRLD klinika nalazi se direktno na Bloku 64, u Omladinskih brigada 96E/4. Za stanovnike kvarta dostupni smo pešice u manje od 10 minuta, što je idealno za pacijente koji dolaze na redovne tretmane fizikalne terapije, rehabilitaciju posle povrede ili sportsku pripremu.',
        whyHere: [
          'Klinika je smeštena u samom srcu Bloka 64 — bez troškova prevoza za naše komšije.',
          'Termini se zakazuju isti dan kada je to klinički moguće.',
          'Parking je dostupan u neposrednoj blizini ulaza u kliniku.',
          'Radimo radnim danima i subotom, sa terminima izvan radnog vremena za zaposlene.',
        ],
        directions: [
          { mode: 'Pešice', description: 'Iz centra Bloka 64 do klinike je 600 m — oko 8 minuta laganog hoda Omladinskih brigada.' },
          { mode: 'Autom', description: 'Vožnja iz svakog dela Bloka 64 je kraća od 3 minuta. Parking ispred zgrade.' },
          { mode: 'Autobusom', description: 'Linije 18, 65, 68, 75 i 88 imaju stajališta u radijusu od 5 minuta hoda do klinike.' },
        ],
        popularServices: [
          'Fizikalna terapija kod bolova u leđima i vratu',
          'Kiropraktika za blokade kičme',
          'Shockwave terapija za tendinopatije',
          'Sportska rehabilitacija povreda kolena i ramena',
          'Manuelna i aparaturna limfna drenaža',
        ],
        nearby: [
          'TC BIG Fashion Outlet',
          'Stark Arena',
          'Belville',
          'Blok 63 i Blok 65',
          'Aleksinačkih rudara',
        ],
        faqs: [
          { question: 'Koliko je PHYSIOWRLD daleko od Bloka 64?', answer: 'Klinika je u Omladinskih brigada 96E/4 — na svega 600 m od centra Bloka 64. Pešačenje traje oko 8 minuta.' },
          { question: 'Da li mogu doći peške na fizikalnu terapiju?', answer: 'Da. Stanovnici Bloka 64 redovno dolaze pešice. Idealno je za pacijente koji moraju izbegavati duga sedenja u kolima nakon povrede.' },
          { question: 'Ima li parking ispred klinike?', answer: 'Da, parking je obezbeđen u neposrednoj blizini ulaza u zgradu.' },
          { question: 'Da li radite vikendom?', answer: 'Radimo subotom. Termini van standardnog radnog vremena dostupni su uz prethodnu najavu.' },
          { question: 'Da li primate hitne slučajeve istog dana?', answer: 'U većini slučajeva da — ako je termin slobodan, naručujemo pacijenta istog dana. Pozovite +381 60 503 7477.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Block 64, New Belgrade',
        metaTitle: 'Physical Therapy Block 64 — PHYSIOWRLD Clinic | New Belgrade',
        metaDesc: 'Physical therapy and rehabilitation for Block 64 residents. PHYSIOWRLD clinic is at Omladinskih brigada 96E/4 — 8 minutes on foot. Call +381 60 503 7477.',
        intro: 'PHYSIOWRLD clinic is located inside Block 64 at Omladinskih brigada 96E/4. For residents of the neighborhood we are reachable on foot in under 10 minutes — ideal for regular physical therapy sessions, post-injury rehabilitation or sports performance work.',
        whyHere: [
          'Located in the heart of Block 64 — no commute needed for our neighbors.',
          'Same-day appointments when clinically possible.',
          'Parking available right by the entrance.',
          'Weekday and Saturday hours, with after-hours slots for working patients.',
        ],
        directions: [
          { mode: 'On foot', description: 'About 600 m from the center of Block 64 — roughly 8 minutes along Omladinskih brigada.' },
          { mode: 'By car', description: 'Drive time from any part of Block 64 is under 3 minutes. Parking in front of the building.' },
          { mode: 'By bus', description: 'Bus lines 18, 65, 68, 75 and 88 stop within a 5-minute walk of the clinic.' },
        ],
        popularServices: [
          'Physical therapy for back and neck pain',
          'Chiropractic for spinal restrictions',
          'Shockwave therapy for tendinopathies',
          'Sports rehabilitation for knee and shoulder injuries',
          'Manual and apparatus lymphatic drainage',
        ],
        nearby: ['BIG Fashion Outlet', 'Stark Arena', 'Belville', 'Blocks 63 and 65', 'Aleksinačkih rudara'],
        faqs: [
          { question: 'How far is PHYSIOWRLD from Block 64?', answer: 'The clinic is at Omladinskih brigada 96E/4 — just 600 m from the center of Block 64, an 8-minute walk.' },
          { question: 'Can I walk to physical therapy?', answer: 'Yes. Block 64 residents regularly walk in. Ideal if you need to avoid long sitting after an injury.' },
          { question: 'Is there parking at the clinic?', answer: 'Yes, parking is available right by the entrance.' },
          { question: 'Are you open on weekends?', answer: 'We are open Saturdays. After-hours slots are available by prior arrangement.' },
          { question: 'Do you accept same-day appointments?', answer: 'Usually yes — call +381 60 503 7477 and we will offer the first free slot.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Блок 64, Новый Белград',
        metaTitle: 'Физиотерапия Блок 64 — клиника PHYSIOWRLD | Новый Белград',
        metaDesc: 'Физиотерапия и реабилитация для жителей Блока 64. PHYSIOWRLD: Omladinskih brigada 96E/4 — 8 минут пешком. Звоните +381 60 503 7477.',
        intro: 'Клиника PHYSIOWRLD расположена в самом Блоке 64 по адресу Omladinskih brigada 96E/4. Для жителей квартала мы в шаговой доступности — идеально для регулярных сеансов физиотерапии и реабилитации.',
        whyHere: [
          'В сердце Блока 64 — без дороги для соседей.',
          'Запись день в день, когда это клинически возможно.',
          'Парковка прямо у входа.',
          'Будние дни и суббота, гибкие слоты.',
        ],
        directions: [
          { mode: 'Пешком', description: 'Около 600 м от центра Блока 64 — примерно 8 минут.' },
          { mode: 'На машине', description: 'Из любой части квартала — менее 3 минут.' },
          { mode: 'Автобусом', description: 'Маршруты 18, 65, 68, 75 и 88 в 5 минутах ходьбы.' },
        ],
        popularServices: ['Физиотерапия при боли в спине и шее', 'Хиропрактика', 'Ударно-волновая терапия', 'Спортивная реабилитация', 'Лимфодренаж'],
        nearby: ['BIG Fashion Outlet', 'Stark Arena', 'Belville', 'Блоки 63 и 65', 'Aleksinačkih rudara'],
        faqs: [
          { question: 'Насколько далеко PHYSIOWRLD от Блока 64?', answer: 'Клиника на Omladinskih brigada 96E/4 — 600 м от центра Блока 64, 8 минут пешком.' },
          { question: 'Есть ли парковка?', answer: 'Да, прямо у входа.' },
          { question: 'Принимаете ли в субботу?', answer: 'Да, по субботам работаем.' },
        ],
      },
    },
  },

  // 2. BELVILLE
  {
    slug: 'fizikalna-terapija-belville',
    name: { sr: 'Belville', en: 'Belville', ru: 'Belville' },
    distanceKm: 1.2,
    walkMinutes: 15,
    driveMinutes: 5,
    relatedDiagnoses: [
      'bol-u-ledjima-tretman-beograd',
      'bol-u-vratu-tretman-beograd',
      'bol-u-ramenu-tretman-beograd',
      'teniski-lakat-tretman-beograd',
      'bol-u-kolenu-tretman-beograd',
    ],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/limfna-drenaza-novi-beograd', label: { sr: 'Limfna drenaža', en: 'Lymphatic drainage', ru: 'Лимфодренаж' } },
      { path: '/presoterapija-novi-beograd', label: { sr: 'Presoterapija', en: 'Pressotherapy', ru: 'Прессотерапия' } },
      { path: '/masaza-novi-beograd', label: { sr: 'Sportska i medicinska masaža', en: 'Sports & medical massage', ru: 'Спортивный массаж' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Belville, Novi Beograd',
        metaTitle: 'Fizikalna terapija Belville — PHYSIOWRLD klinika | Novi Beograd',
        metaDesc: 'Fizikalna terapija, sportska masaža i limfna drenaža za stanovnike Belvillea. PHYSIOWRLD je u Omladinskih brigada 96E/4 — 5 minuta autom. +381 60 503 7477.',
        intro: 'PHYSIOWRLD klinika je svega 1,2 km od kompleksa Belville na Novom Beogradu. Za stanovnike Belvillea smo prva adresa za fizikalnu terapiju, sportsku rehabilitaciju i wellness tretmane bez gužve i čekanja u domu zdravlja.',
        whyHere: [
          'Klinika je dostupna autom za 5 minuta iz svake zgrade Belvillea.',
          'Veliki broj klijenata su zaposleni iz okolnih poslovnih zgrada — radimo i posle 17h.',
          'Sportski klijenti iz Stark Arene i obližnjih teretana koriste naš shockwave i kineziterapiju.',
          'Termini se često spajaju (drenaža + presoterapija) u jednoj poseti.',
        ],
        directions: [
          { mode: 'Pešice', description: 'Iz Belvillea pešačenje do klinike traje oko 15 minuta — pravac Omladinskih brigada.' },
          { mode: 'Autom', description: 'Vožnja traje 5 minuta. Parking ispred zgrade klinike.' },
          { mode: 'Autobusom', description: 'Linije sa Belvillea ka Bloku 64 dovode vas na 200 m od ulaza.' },
        ],
        popularServices: [
          'Manuelna limfna drenaža i presoterapija',
          'Sportska masaža za vežbače iz okolnih teretana',
          'Rehabilitacija povreda iz teretane (rame, leđa, koleno)',
          'Anticelulit i body care tretmani',
          'Fizikalna terapija pri sedentarnom kancelarijskom poslu',
        ],
        nearby: ['Belville stadion', 'TC Mercator', 'Stark Arena', 'Sava Centar', 'Blok 67'],
        faqs: [
          { question: 'Koliko traje vožnja iz Belvillea do klinike?', answer: 'Oko 5 minuta autom. Pešice oko 15 minuta.' },
          { question: 'Da li primate klijente posle posla?', answer: 'Da, imamo termine i nakon 17h — pogodno za zaposlene iz okolnih biznis tornjeva.' },
          { question: 'Mogu li kombinovati više tretmana u jednoj poseti?', answer: 'Da. Najpopularnija kombinacija je manuelna drenaža i presoterapija — ukupno 45-60 minuta.' },
          { question: 'Imate li paket cene za redovne tretmane?', answer: 'Da, paketi tretmana imaju popust u odnosu na pojedinačne cene. Pozovite za aktuelne pakete.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Belville, New Belgrade',
        metaTitle: 'Physical Therapy Belville — PHYSIOWRLD | New Belgrade',
        metaDesc: 'Physical therapy, sports massage and lymphatic drainage for Belville residents. PHYSIOWRLD is at Omladinskih brigada 96E/4 — 5 min by car. +381 60 503 7477.',
        intro: 'PHYSIOWRLD clinic is just 1.2 km from the Belville complex in New Belgrade. We are the go-to address for residents seeking physical therapy, sports rehabilitation and wellness without long public-clinic queues.',
        whyHere: [
          'Reachable by car in 5 minutes from any Belville building.',
          'Many clients are office workers from nearby towers — after 5 PM slots available.',
          'Athletes from Stark Arena and nearby gyms use our shockwave and exercise therapy.',
          'Sessions can be combined (drainage + pressotherapy) in one visit.',
        ],
        directions: [
          { mode: 'On foot', description: 'About a 15-minute walk along Omladinskih brigada.' },
          { mode: 'By car', description: '5 minutes. Parking right by the entrance.' },
          { mode: 'By bus', description: 'Lines from Belville to Block 64 drop you 200 m from the entrance.' },
        ],
        popularServices: ['Manual lymphatic drainage & pressotherapy', 'Sports massage', 'Gym-injury rehabilitation', 'Anti-cellulite & body care', 'Office-worker physical therapy'],
        nearby: ['Belville Stadium', 'Mercator', 'Stark Arena', 'Sava Centar', 'Block 67'],
        faqs: [
          { question: 'How long is the drive from Belville?', answer: 'About 5 minutes. Roughly 15 minutes on foot.' },
          { question: 'Do you have after-work appointments?', answer: 'Yes, we have slots after 5 PM for office workers from nearby business towers.' },
          { question: 'Can I combine treatments?', answer: 'Yes — the most popular combo is manual drainage + pressotherapy, 45-60 min total.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Belville, Новый Белград',
        metaTitle: 'Физиотерапия Belville — клиника PHYSIOWRLD',
        metaDesc: 'Физиотерапия, спортивный массаж и лимфодренаж для жителей Belville. PHYSIOWRLD: Omladinskih brigada 96E/4 — 5 минут на машине.',
        intro: 'Клиника PHYSIOWRLD всего в 1,2 км от комплекса Belville. Для жителей квартала — основное место для физиотерапии, спортивной реабилитации и wellness.',
        whyHere: ['5 минут на машине из любого корпуса Belville.', 'Слоты после 17:00 для офисных работников.', 'Совмещение процедур в одном визите.'],
        directions: [
          { mode: 'Пешком', description: 'Около 15 минут.' },
          { mode: 'На машине', description: '5 минут. Парковка у входа.' },
          { mode: 'Автобусом', description: 'Линии Belville → Блок 64 в 200 м от входа.' },
        ],
        popularServices: ['Лимфодренаж и прессотерапия', 'Спортивный массаж', 'Реабилитация после травм', 'Антицеллюлитные процедуры'],
        nearby: ['Belville Stadium', 'TC Mercator', 'Stark Arena', 'Sava Centar', 'Блок 67'],
        faqs: [
          { question: 'Как долго ехать из Belville?', answer: 'Около 5 минут на машине.' },
          { question: 'Есть ли вечерние слоты?', answer: 'Да, после 17:00.' },
        ],
      },
    },
  },

  // 3. BEOGRAD NA VODI
  {
    slug: 'fizikalna-terapija-beograd-na-vodi',
    name: { sr: 'Beograd na vodi', en: 'Belgrade Waterfront', ru: 'Белград на воде' },
    distanceKm: 4.5,
    walkMinutes: 55,
    driveMinutes: 10,
    relatedDiagnoses: [
      'bol-u-vratu-tretman-beograd',
      'bol-u-ledjima-tretman-beograd',
      'karpalni-tunel-tretman-beograd',
      'diskus-hernija-tretman-beograd',
      'bol-u-ramenu-tretman-beograd',
    ],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/shockwave-terapija-novi-beograd', label: { sr: 'Shockwave terapija', en: 'Shockwave therapy', ru: 'Ударно-волновая терапия' } },
      { path: '/skidanje-masti-novi-beograd', label: { sr: 'Skidanje masti', en: 'Fat removal', ru: 'Удаление жира' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija za stanovnike Beograda na vodi',
        metaTitle: 'Fizikalna terapija Beograd na vodi — PHYSIOWRLD | Novi Beograd',
        metaDesc: 'Premium fizikalna terapija i body care za stanovnike Beograda na vodi. PHYSIOWRLD klinika — 10 minuta autom preko Ade. +381 60 503 7477.',
        intro: 'PHYSIOWRLD klinika nalazi se na Novom Beogradu, 10 minuta autom od Beograda na vodi preko mosta na Adi. Naši klijenti iz BW Quartet, BW Aria i Galerije Beograd biraju nas zbog profesionalnog tima, modernih aparata i diskretne atmosfere prilagođene zahtevima premium klijentele.',
        whyHere: [
          'Brza komunikacija preko Save preko mosta na Adi — 10 minuta od Beograda na vodi.',
          'Diskrecija i privatnost — termini se zakazuju individualno, bez čekaonice u gužvi.',
          'Premium oprema: HILT laser, fokusirani shockwave, profesionalne presoterapije.',
          'Engleski govorni terapeut — komforno za međunarodne klijente.',
        ],
        directions: [
          { mode: 'Autom', description: 'Od BW Quartet preko mosta na Adi do Bloka 64 vožnja je 10 minuta van špica.' },
          { mode: 'Taksijem / Bolt', description: 'Vožnja je u ekonomskoj zoni — najčešće 700-1000 RSD.' },
          { mode: 'Šetnjom', description: 'Za one koji žele kombinaciju vežbe i terapije — šetnja Adom je oko 50 minuta.' },
        ],
        popularServices: [
          'Fizikalna terapija nakon sedentarnog rada (vrat, leđa)',
          'Kiropraktika i manuelna terapija',
          'Shockwave terapija za sportske povrede',
          'Body care: skidanje masti, anticelulit, presoterapija',
          'Sportska masaža za rekreativce iz BW Wellness',
        ],
        nearby: ['BW Quartet', 'BW Aria', 'Galerija Beograd Mall', 'Beton Hala', 'Ada Most'],
        faqs: [
          { question: 'Koliko traje vožnja iz Beograda na vodi do klinike?', answer: 'Oko 10 minuta van špica preko mosta na Adi.' },
          { question: 'Da li je termin diskretan?', answer: 'Da. Termini se zakazuju individualno; čekaonica nije pretrpana.' },
          { question: 'Govorite li engleski?', answer: 'Da, klijente primamo i na engleskom.' },
          { question: 'Imate li tretmane skidanja masti i anticelulita?', answer: 'Da — Shockwave AWT, presoterapija i anticelulit protokoli su dostupni.' },
        ],
      },
      en: {
        h1: 'Physical therapy for Belgrade Waterfront residents',
        metaTitle: 'Physical Therapy Belgrade Waterfront — PHYSIOWRLD',
        metaDesc: 'Premium physical therapy and body care for Belgrade Waterfront residents. PHYSIOWRLD — 10 min by car across Ada Bridge. +381 60 503 7477.',
        intro: 'PHYSIOWRLD clinic is in New Belgrade, 10 minutes by car from Belgrade Waterfront via the Ada Bridge. Our clients from BW Quartet, BW Aria and Galerija Beograd value our professional team, modern equipment and discreet, premium-friendly atmosphere.',
        whyHere: [
          'Quick connection across the Sava via Ada Bridge — 10 minutes from Waterfront.',
          'Discretion and privacy — individual scheduling, no crowded waiting room.',
          'Premium equipment: HILT laser, focused shockwave, professional pressotherapy.',
          'English-speaking therapists — convenient for international clients.',
        ],
        directions: [
          { mode: 'By car', description: 'From BW Quartet across Ada Bridge to Block 64 in 10 minutes outside rush hour.' },
          { mode: 'Taxi / Bolt', description: 'Within the economy zone — usually 700-1000 RSD.' },
          { mode: 'On foot', description: 'For those who want exercise + therapy — about 50 minutes via Ada.' },
        ],
        popularServices: ['Physical therapy after sedentary work', 'Chiropractic and manual therapy', 'Shockwave for sports injuries', 'Body care: fat removal, anti-cellulite, pressotherapy', 'Sports massage'],
        nearby: ['BW Quartet', 'BW Aria', 'Galerija Belgrade Mall', 'Beton Hala', 'Ada Bridge'],
        faqs: [
          { question: 'How long is the drive from Belgrade Waterfront?', answer: 'About 10 minutes outside rush hour via Ada Bridge.' },
          { question: 'Is the appointment discreet?', answer: 'Yes — individual scheduling, no crowded waiting room.' },
          { question: 'Do you speak English?', answer: 'Yes, we treat international clients in English.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия для жителей Belgrade Waterfront',
        metaTitle: 'Физиотерапия Belgrade Waterfront — PHYSIOWRLD',
        metaDesc: 'Премиум физиотерапия и body care для жителей Belgrade Waterfront. PHYSIOWRLD — 10 минут на машине через мост Ada.',
        intro: 'Клиника PHYSIOWRLD в Новом Белграде, 10 минут на машине от Belgrade Waterfront через мост Ada.',
        whyHere: ['10 минут через мост Ada.', 'Дискретность и приватность.', 'Премиум оборудование.', 'Англоговорящие терапевты.'],
        directions: [
          { mode: 'На машине', description: '10 минут вне часа пик.' },
          { mode: 'Такси', description: '700-1000 RSD.' },
          { mode: 'Пешком', description: '~50 минут через Аду.' },
        ],
        popularServices: ['Физиотерапия при сидячей работе', 'Хиропрактика', 'Ударно-волновая терапия', 'Body care'],
        nearby: ['BW Quartet', 'BW Aria', 'Galerija', 'Beton Hala', 'Ada Bridge'],
        faqs: [
          { question: 'Сколько ехать?', answer: 'Около 10 минут.' },
          { question: 'Говорите по-английски?', answer: 'Да.' },
        ],
      },
    },
  },

  // 4. ZEMUN
  {
    slug: 'fizikalna-terapija-zemun',
    name: { sr: 'Zemun', en: 'Zemun', ru: 'Земун' },
    distanceKm: 5.5,
    walkMinutes: 70,
    driveMinutes: 12,
    relatedDiagnoses: [
      'teniski-lakat-tretman-beograd',
      'golferski-lakat-tretman-beograd',
      'acl-rehabilitacija-beograd',
      'meniskus-rehabilitacija-beograd',
      'ahilova-tetiva-tretman-beograd',
      'petni-trn',
    ],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/shockwave-terapija-novi-beograd', label: { sr: 'Shockwave terapija', en: 'Shockwave therapy', ru: 'Ударно-волновая терапия' } },
      { path: '/limfna-drenaza-novi-beograd', label: { sr: 'Limfna drenaža', en: 'Lymphatic drainage', ru: 'Лимфодренаж' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija za stanovnike Zemuna',
        metaTitle: 'Fizikalna terapija Zemun — PHYSIOWRLD klinika | Novi Beograd',
        metaDesc: 'Fizikalna terapija, kiropraktika i shockwave za stanovnike Zemuna. PHYSIOWRLD klinika je 12 minuta autom — Novi Beograd. +381 60 503 7477.',
        intro: 'Klijenti iz Zemuna do PHYSIOWRLD klinike na Bloku 64 stižu za oko 12 minuta autom magistralnim pravcem. Specijalizovani smo za fizikalnu terapiju, kiropraktiku, shockwave terapiju i sportsku rehabilitaciju — usluge koje u Zemunu često zahtevaju duga čekanja.',
        whyHere: [
          'Brz dolazak autom — 12 minuta van špica, bez prelaska reka.',
          'Sveobuhvatna usluga: dijagnoza, terapija i kineziterapija u istoj poseti.',
          'Specijalizacija za sportske povrede — radimo sa amaterskim klubovima iz Zemuna.',
          'Subotnji termini za pacijente koji rade preko nedelje.',
        ],
        directions: [
          { mode: 'Autom', description: 'Magistralnim pravcem od centra Zemuna do Bloka 64 vožnja je oko 12 minuta.' },
          { mode: 'Autobusom', description: 'Linije 17, 73 i 78 vode iz Zemuna ka Bloku 64 — 25-35 minuta vožnje.' },
          { mode: 'Taksijem', description: 'Vožnja je u standardnoj zoni — orijentaciono 800-1200 RSD.' },
        ],
        popularServices: [
          'Fizikalna terapija kod lumbalnog i cervikalnog sindroma',
          'Kiropraktika i manuelna mobilizacija',
          'Shockwave terapija za teniski lakat i petni trn',
          'Sportska rehabilitacija povreda iz fudbalskih i košarkaških klubova',
          'Postoperativna rehabilitacija (kuk, koleno, rame)',
        ],
        nearby: ['Gardoš', 'TC Big Zemun', 'Zemunski kej', 'Galenika', 'Altina'],
        faqs: [
          { question: 'Koliko traje vožnja iz Zemuna do klinike?', answer: 'Oko 12 minuta autom van špica magistralnim pravcem.' },
          { question: 'Mogu li doći autobusom?', answer: 'Da, linije 17, 73 i 78 vode iz Zemuna ka Bloku 64. Vožnja traje 25-35 minuta.' },
          { question: 'Da li primate hitne sportske povrede?', answer: 'Da — pozovite odmah i u većini slučajeva primamo isti dan.' },
          { question: 'Da li dolazite u kuću?', answer: 'Standardni tretmani se obavljaju u klinici. Za posebne slučajeve kontaktirajte nas i razmotrićemo opcije.' },
        ],
      },
      en: {
        h1: 'Physical therapy for Zemun residents',
        metaTitle: 'Physical Therapy Zemun — PHYSIOWRLD Clinic | New Belgrade',
        metaDesc: 'Physical therapy, chiropractic and shockwave for Zemun residents. PHYSIOWRLD clinic is 12 min by car in New Belgrade. +381 60 503 7477.',
        intro: 'Patients from Zemun reach PHYSIOWRLD clinic in Block 64 in about 12 minutes by car via the main road. We specialize in physical therapy, chiropractic, shockwave and sports rehabilitation — services that often involve long waits in Zemun public clinics.',
        whyHere: [
          'Fast access by car — 12 minutes outside rush hour, no river crossings.',
          'Comprehensive service: diagnosis, treatment and exercise therapy in one visit.',
          'Sports-injury specialization — we work with amateur clubs from Zemun.',
          'Saturday slots for patients who work weekdays.',
        ],
        directions: [
          { mode: 'By car', description: 'About 12 minutes via the main road from central Zemun to Block 64.' },
          { mode: 'By bus', description: 'Lines 17, 73 and 78 — 25-35 minutes from Zemun.' },
          { mode: 'Taxi', description: 'Standard zone — roughly 800-1200 RSD.' },
        ],
        popularServices: ['Physical therapy for lumbar and cervical syndrome', 'Chiropractic and manual mobilization', 'Shockwave for tennis elbow and heel spur', 'Sports rehabilitation', 'Post-op rehabilitation (hip, knee, shoulder)'],
        nearby: ['Gardoš', 'BIG Zemun', 'Zemun Quay', 'Galenika', 'Altina'],
        faqs: [
          { question: 'How long is the drive from Zemun?', answer: 'About 12 minutes by car outside rush hour.' },
          { question: 'Can I come by bus?', answer: 'Yes — lines 17, 73 and 78, 25-35 minutes.' },
          { question: 'Do you accept urgent sports injuries?', answer: 'Yes — call us and we usually fit you in the same day.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия для жителей Земуна',
        metaTitle: 'Физиотерапия Земун — PHYSIOWRLD',
        metaDesc: 'Физиотерапия, хиропрактика и УВТ для жителей Земуна. PHYSIOWRLD — 12 минут на машине.',
        intro: 'Из Земуна до клиники PHYSIOWRLD в Блоке 64 — около 12 минут на машине.',
        whyHere: ['12 минут на машине.', 'Полный сервис в один визит.', 'Работаем с местными спортклубами.', 'Субботние слоты.'],
        directions: [
          { mode: 'На машине', description: '~12 минут.' },
          { mode: 'Автобусом', description: 'Линии 17, 73, 78 — 25-35 минут.' },
          { mode: 'Такси', description: '800-1200 RSD.' },
        ],
        popularServices: ['Физиотерапия', 'Хиропрактика', 'УВТ', 'Спортивная реабилитация'],
        nearby: ['Gardoš', 'BIG Zemun', 'Zemun Quay', 'Galenika', 'Altina'],
        faqs: [
          { question: 'Сколько ехать?', answer: '~12 минут.' },
          { question: 'Работаете в субботу?', answer: 'Да.' },
        ],
      },
    },
  },

  // 5. BEŽANIJSKA KOSA
  {
    slug: 'fizikalna-terapija-bezanijska-kosa',
    name: { sr: 'Bežanijska Kosa', en: 'Bežanijska Kosa', ru: 'Бежанийска Коса' },
    distanceKm: 3.2,
    walkMinutes: 40,
    driveMinutes: 7,
    relatedDiagnoses: [
      'bol-u-kuku-tretman-beograd',
      'bol-u-kolenu-tretman-beograd',
      'acl-rehabilitacija-beograd',
      'meniskus-rehabilitacija-beograd',
      'frozen-shoulder-tretman-beograd',
      'bol-u-ledjima-tretman-beograd',
    ],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/laser-terapija-novi-beograd', label: { sr: 'Laser terapija', en: 'Laser therapy', ru: 'Лазеротерапия' } },
      { path: '/presoterapija-novi-beograd', label: { sr: 'Presoterapija', en: 'Pressotherapy', ru: 'Прессотерапия' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija za stanovnike Bežanijske Kose',
        metaTitle: 'Fizikalna terapija Bežanijska Kosa — PHYSIOWRLD klinika',
        metaDesc: 'Fizikalna terapija, kiropraktika i laser za Bežanijsku Kosu. PHYSIOWRLD klinika — 7 minuta autom, Blok 64. Pozovite +381 60 503 7477.',
        intro: 'PHYSIOWRLD klinika je svega 7 minuta autom od Bežanijske Kose. Stanovnici Kose biraju nas zbog brze dostupnosti, modernih aparata (HILT laser, fokusirani shockwave) i terapeuta sa kliničkim iskustvom u rehabilitaciji posle operacija i sportskih povreda.',
        whyHere: [
          'Brza komunikacija autom — 7 minuta od centra Bežanijske Kose.',
          'Specijalizovani smo za rehabilitaciju posle operacija — kuk, koleno, rame, kičma.',
          'Subotnji i kasni popodnevni termini za zaposlene.',
          'Saradnja sa ortopedima i fizijatrima iz okolnih ustanova.',
        ],
        directions: [
          { mode: 'Autom', description: 'Od centra Bežanijske Kose do Bloka 64 vožnja je oko 7 minuta van špica.' },
          { mode: 'Autobusom', description: 'Linije sa Bežanijske Kose ka Novom Beogradu — 20-25 minuta vožnje.' },
          { mode: 'Pešice', description: 'Za one koji žele duži hod — oko 40 minuta.' },
        ],
        popularServices: [
          'Postoperativna rehabilitacija (kuk, koleno, rame, kičma)',
          'Kiropraktika i manuelna mobilizacija',
          'HILT laser terapija za bolne sindrome',
          'Fizikalna terapija starijih pacijenata',
          'Presoterapija i limfna drenaža',
        ],
        nearby: ['KBC Bežanijska Kosa', 'TC Stop Shop', 'Aerodrom Nikola Tesla (smer)', 'Ledine', 'Surčin'],
        faqs: [
          { question: 'Koliko traje vožnja iz Bežanijske Kose?', answer: 'Oko 7 minuta autom van špica.' },
          { question: 'Radite li sa pacijentima posle operacije iz KBC Bežanijska Kosa?', answer: 'Da. Postoperativna rehabilitacija (kuk, koleno, rame, kičma) je naša fokus oblast.' },
          { question: 'Da li primate starije pacijente?', answer: 'Da. Tretmani su prilagođeni dobi i toleranciji pacijenta. Klinika je pristupačna.' },
          { question: 'Da li sarađujete sa lekarima?', answer: 'Da — primamo pacijente sa uputom ortopeda, fizijatra ili neurologa, ali i bez uputa.' },
        ],
      },
      en: {
        h1: 'Physical therapy for Bežanijska Kosa residents',
        metaTitle: 'Physical Therapy Bežanijska Kosa — PHYSIOWRLD',
        metaDesc: 'Physical therapy, chiropractic and laser for Bežanijska Kosa. PHYSIOWRLD clinic — 7 min by car. Call +381 60 503 7477.',
        intro: 'PHYSIOWRLD clinic is just 7 minutes by car from Bežanijska Kosa. Local residents choose us for quick access, modern equipment (HILT laser, focused shockwave) and therapists experienced in post-op and sports rehabilitation.',
        whyHere: [
          'Quick car access — 7 minutes from central Bežanijska Kosa.',
          'Post-op rehabilitation specialization — hip, knee, shoulder, spine.',
          'Saturday and late-afternoon slots for working patients.',
          'Cooperation with orthopedists and physiatrists from nearby facilities.',
        ],
        directions: [
          { mode: 'By car', description: 'About 7 minutes from central Bežanijska Kosa to Block 64.' },
          { mode: 'By bus', description: 'Lines from Bežanijska Kosa to New Belgrade — 20-25 minutes.' },
          { mode: 'On foot', description: 'For a longer walk — about 40 minutes.' },
        ],
        popularServices: ['Post-op rehabilitation (hip, knee, shoulder, spine)', 'Chiropractic and manual mobilization', 'HILT laser for pain syndromes', 'Senior-patient physical therapy', 'Pressotherapy and lymphatic drainage'],
        nearby: ['Bežanijska Kosa Hospital', 'Stop Shop', 'Nikola Tesla Airport (direction)', 'Ledine', 'Surčin'],
        faqs: [
          { question: 'How long is the drive?', answer: 'About 7 minutes outside rush hour.' },
          { question: 'Do you work with post-op patients from Bežanijska Kosa Hospital?', answer: 'Yes. Post-op rehabilitation is one of our focus areas.' },
          { question: 'Do you accept senior patients?', answer: 'Yes. Treatments are adapted to age and tolerance. The clinic is accessible.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия для жителей Бежанийской Косы',
        metaTitle: 'Физиотерапия Бежанийска Коса — PHYSIOWRLD',
        metaDesc: 'Физиотерапия, хиропрактика и лазер для Бежанийской Косы. PHYSIOWRLD — 7 минут на машине.',
        intro: 'Клиника PHYSIOWRLD в 7 минутах на машине от Бежанийской Косы.',
        whyHere: ['7 минут на машине.', 'Специализация на послеоперационной реабилитации.', 'Субботние слоты.', 'Сотрудничество с ортопедами.'],
        directions: [
          { mode: 'На машине', description: '~7 минут.' },
          { mode: 'Автобусом', description: '20-25 минут.' },
          { mode: 'Пешком', description: '~40 минут.' },
        ],
        popularServices: ['Послеоперационная реабилитация', 'Хиропрактика', 'HILT лазер', 'Физиотерапия пожилых', 'Прессотерапия'],
        nearby: ['Больница Bežanijska Kosa', 'Stop Shop', 'Аэропорт', 'Ledine', 'Surčin'],
        faqs: [
          { question: 'Сколько ехать?', answer: '~7 минут.' },
          { question: 'Принимаете пожилых?', answer: 'Да, программа адаптируется.' },
        ],
      },
    },
  },
  // 6. BLOK 70 (Novi Beograd)
  {
    slug: 'fizikalna-terapija-blok-70',
    name: { sr: 'Blok 70', en: 'Block 70', ru: 'Блок 70' },
    distanceKm: 1.2,
    walkMinutes: 15,
    driveMinutes: 5,
    relatedDiagnoses: ['bol-u-ledjima-tretman-beograd', 'bol-u-kolenu-tretman-beograd', 'isijas-tretman-beograd', 'frozen-shoulder-tretman-beograd'],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/limfna-drenaza-novi-beograd', label: { sr: 'Limfna drenaža', en: 'Lymphatic drainage', ru: 'Лимфодренаж' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Blok 70, Novi Beograd',
        metaTitle: 'Fizikalna terapija Blok 70 | PHYSIOWRLD Novi Beograd',
        metaDesc: 'Klinika PHYSIOWRLD — 5 minuta autom od Bloka 70. Fizikalna terapija, kiropraktika, drenaža i shockwave. Pozovite +381 60 503 7477.',
        intro: 'Za stanovnike Bloka 70 PHYSIOWRLD klinika je dostupna autom za 5 minuta. Pacijenti dolaze na fizikalnu terapiju, drenažu posle estetskih intervencija i sportsku rehabilitaciju.',
        whyHere: [
          'Vožnja iz Bloka 70 traje 5-7 minuta.',
          'Iskusan tim za postoperativnu drenažu — popularan zahtev iz kvarta.',
          'Termini van standardnog radnog vremena za zaposlene.',
          'Parking ispred ulaza.',
        ],
        directions: [
          { mode: 'Autom', description: 'Brzina 1 i Omladinskih brigada — pravi pravac, oko 5 minuta vožnje.' },
          { mode: 'Autobusom', description: 'Linije 65, 68 i 88 imaju direktnu vezu sa Blokom 70.' },
          { mode: 'Pešice', description: 'Za sportski hod oko 15 minuta — pogodno za rekreativce.' },
        ],
        popularServices: ['Manuelna i aparaturna limfna drenaža', 'Fizikalna terapija lumbalnog sindroma', 'Kiropraktika', 'Shockwave AWT za skidanje masti', 'Sportska rehabilitacija'],
        nearby: ['Tržni centar Piramida', 'Sava Centar', 'Hotel Crowne Plaza', 'Blok 19', 'Reka Sava'],
        faqs: [
          { question: 'Koliko je vožnja iz Bloka 70?', answer: 'Oko 5 minuta autom — najbrži pravac je Brzinom 1 do Omladinskih brigada.' },
          { question: 'Da li radite postoperativnu drenažu?', answer: 'Da, manuelnu i aparaturnu — sa fizioterapeutom obučenim za rad sa pacijentima posle liposukcije i estetskih intervencija.' },
          { question: 'Ima li parking?', answer: 'Da, parking je ispred ulaza u zgradu.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Block 70, New Belgrade',
        metaTitle: 'Physical Therapy Block 70 | PHYSIOWRLD New Belgrade',
        metaDesc: 'PHYSIOWRLD clinic — 5 minutes by car from Block 70. Physical therapy, chiropractic, drainage and shockwave. Call +381 60 503 7477.',
        intro: 'For Block 70 residents, PHYSIOWRLD is a 5-minute drive away. Patients come for physical therapy, post-aesthetic drainage and sports rehabilitation.',
        whyHere: ['5-7 minute drive from Block 70.', 'Experienced post-operative drainage team.', 'After-hours slots for working patients.', 'Parking right by the entrance.'],
        directions: [
          { mode: 'By car', description: 'Brzina 1 + Omladinskih brigada — direct route, ~5 minutes.' },
          { mode: 'By bus', description: 'Lines 65, 68 and 88 connect directly to Block 70.' },
          { mode: 'On foot', description: '~15 minutes brisk walk.' },
        ],
        popularServices: ['Manual & apparatus lymphatic drainage', 'Lumbar pain physical therapy', 'Chiropractic', 'Shockwave AWT for fat reduction', 'Sports rehabilitation'],
        nearby: ['Piramida Mall', 'Sava Centar', 'Crowne Plaza Hotel', 'Block 19', 'River Sava'],
        faqs: [
          { question: 'How long from Block 70?', answer: '~5 minutes by car along Brzina 1.' },
          { question: 'Do you provide post-op drainage?', answer: 'Yes — both manual and apparatus, with a therapist trained in post-liposuction care.' },
          { question: 'Is there parking?', answer: 'Yes, directly in front of the entrance.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Блок 70, Новый Белград',
        metaTitle: 'Физиотерапия Блок 70 | PHYSIOWRLD Новый Белград',
        metaDesc: 'PHYSIOWRLD — 5 минут на машине от Блока 70. Физиотерапия, хиропрактика, дренаж и ударно-волновая. Звоните +381 60 503 7477.',
        intro: 'Для жителей Блока 70 PHYSIOWRLD доступен за 5 минут на машине. Чаще всего обращаются за физиотерапией, послеоперационным дренажом и спортивной реабилитацией.',
        whyHere: ['5-7 минут на машине.', 'Опытная команда послеоперационного дренажа.', 'Гибкие слоты после работы.', 'Парковка у входа.'],
        directions: [
          { mode: 'На машине', description: 'Brzina 1 + Omladinskih brigada, ~5 минут.' },
          { mode: 'Автобусом', description: 'Маршруты 65, 68 и 88.' },
          { mode: 'Пешком', description: '~15 минут быстрым шагом.' },
        ],
        popularServices: ['Ручной и аппаратный дренаж', 'Физиотерапия поясницы', 'Хиропрактика', 'УВТ для жира', 'Спортивная реабилитация'],
        nearby: ['ТЦ Piramida', 'Sava Centar', 'Crowne Plaza', 'Блок 19', 'Сава'],
        faqs: [
          { question: 'Сколько ехать?', answer: '~5 минут.' },
          { question: 'Делаете ли послеоперационный дренаж?', answer: 'Да — ручной и аппаратный.' },
        ],
      },
    },
  },
  // 7. BLOK 45 (Novi Beograd)
  {
    slug: 'fizikalna-terapija-blok-45',
    name: { sr: 'Blok 45', en: 'Block 45', ru: 'Блок 45' },
    distanceKm: 2.4,
    walkMinutes: 30,
    driveMinutes: 8,
    relatedDiagnoses: ['bol-u-kolenu-tretman-beograd', 'acl-rehabilitacija-beograd', 'meniskus-rehabilitacija-beograd', 'ahilova-tetiva-tretman-beograd'],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/shockwave-terapija-novi-beograd', label: { sr: 'Shockwave terapija', en: 'Shockwave therapy', ru: 'УВТ' } },
      { path: '/services/kinesitherapy', label: { sr: 'Kineziterapija', en: 'Kinesiotherapy', ru: 'Кинезитерапия' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Blok 45, Novi Beograd',
        metaTitle: 'Fizikalna terapija Blok 45 | PHYSIOWRLD Novi Beograd',
        metaDesc: 'PHYSIOWRLD klinika 8 minuta autom od Bloka 45. Fizikalna terapija, sportska rehabilitacija i shockwave. Pozovite +381 60 503 7477.',
        intro: 'Iz Bloka 45 i okolnih kvartova uz Adu (Blok 44, 70a, Adi Huja) dolazi nam značajan broj rekreativaca i sportista. Specijalizovani smo za sportsku rehabilitaciju i tretman tendinopatija.',
        whyHere: ['Vožnja iz Bloka 45 oko 8 minuta.', 'Tim sa iskustvom u sportskoj rehabilitaciji.', 'Shockwave protokoli za trkače i biciklise iz okoline Ade.', 'Parking ispred ulaza.'],
        directions: [
          { mode: 'Autom', description: 'Jurija Gagarina + Brzina 1 + Omladinskih brigada — oko 8 minuta.' },
          { mode: 'Autobusom', description: 'Linija 65 i 88 imaju direktnu vezu sa Blokom 45.' },
          { mode: 'Pešice', description: 'Oko 30 minuta hoda — pogodno za trkače kao deo zagrevanja.' },
        ],
        popularServices: ['Sportska rehabilitacija', 'Shockwave za Ahilovu tetivu', 'Kineziterapija posle ACL rekonstrukcije', 'Fizikalna terapija kolena', 'Manuelna terapija'],
        nearby: ['Ada Ciganlija', 'Sportski centar Blok 45', 'Hipodrom', 'Blok 44 i 70a', 'Most na Adi'],
        faqs: [
          { question: 'Koliko je daleko Blok 45?', answer: 'Oko 8 minuta autom — pravi pravac je Jurija Gagarina pa Brzina 1.' },
          { question: 'Radite li sa trkačima sa Ade?', answer: 'Da. Specijalizovani smo za tretman Ahilove tendinopatije, šin splinta i preopterećenja kolena kod rekreativaca.' },
          { question: 'Ima li parking?', answer: 'Da, parking je ispred ulaza u zgradu.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Block 45, New Belgrade',
        metaTitle: 'Physical Therapy Block 45 | PHYSIOWRLD New Belgrade',
        metaDesc: 'PHYSIOWRLD clinic 8 minutes by car from Block 45. Physical therapy, sports rehab and shockwave. Call +381 60 503 7477.',
        intro: 'From Block 45 and surrounding riverside neighborhoods we treat many recreational athletes and runners — with a focus on sports rehab and tendinopathies.',
        whyHere: ['~8 minute drive.', 'Experienced sports rehab team.', 'Shockwave protocols for Ada runners and cyclists.', 'Parking at the entrance.'],
        directions: [
          { mode: 'By car', description: 'Jurija Gagarina + Brzina 1 + Omladinskih brigada — ~8 minutes.' },
          { mode: 'By bus', description: 'Lines 65 and 88 connect directly to Block 45.' },
          { mode: 'On foot', description: '~30 minutes — possible as a warm-up for runners.' },
        ],
        popularServices: ['Sports rehabilitation', 'Achilles shockwave', 'Post-ACL kinesiotherapy', 'Knee physical therapy', 'Manual therapy'],
        nearby: ['Ada Ciganlija', 'Block 45 Sports Centre', 'Hippodrome', 'Blocks 44 and 70a', 'Ada Bridge'],
        faqs: [
          { question: 'How far from Block 45?', answer: '~8 minutes by car via Jurija Gagarina.' },
          { question: 'Do you treat Ada runners?', answer: 'Yes — Achilles tendinopathy, shin splints and overload knee pain are routine cases.' },
          { question: 'Is there parking?', answer: 'Yes, at the entrance.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Блок 45, Новый Белград',
        metaTitle: 'Физиотерапия Блок 45 | PHYSIOWRLD Новый Белград',
        metaDesc: 'PHYSIOWRLD — 8 минут на машине от Блока 45. Физиотерапия, спортивная реабилитация и УВТ. Звоните +381 60 503 7477.',
        intro: 'Из Блока 45 и прибрежных кварталов к нам приходят бегуны и любители — специализация на спортивной реабилитации и тендинопатиях.',
        whyHere: ['~8 минут на машине.', 'Опытная команда спортивной реабилитации.', 'УВТ для бегунов с Ada Ciganlija.', 'Парковка у входа.'],
        directions: [
          { mode: 'На машине', description: '~8 минут.' },
          { mode: 'Автобусом', description: 'Маршруты 65 и 88.' },
          { mode: 'Пешком', description: '~30 минут.' },
        ],
        popularServices: ['Спортивная реабилитация', 'УВТ ахилла', 'Кинезитерапия после ПКС', 'Физиотерапия колена', 'Мануальная терапия'],
        nearby: ['Ada Ciganlija', 'Спортцентр Блок 45', 'Ипподром', 'Блоки 44 и 70a', 'Мост на Аде'],
        faqs: [
          { question: 'Сколько ехать?', answer: '~8 минут.' },
          { question: 'Лечите бегунов?', answer: 'Да — ахиллова тендинопатия, шинсплинт.' },
        ],
      },
    },
  },
  // 8. SAVSKI VENAC
  {
    slug: 'fizikalna-terapija-savski-venac',
    name: { sr: 'Savski venac', en: 'Savski Venac', ru: 'Савски Венац' },
    distanceKm: 4.2,
    walkMinutes: 55,
    driveMinutes: 12,
    relatedDiagnoses: ['bol-u-vratu-tretman-beograd', 'bol-u-ledjima-tretman-beograd', 'karpalni-tunel-tretman-beograd', 'frozen-shoulder-tretman-beograd'],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/laser-terapija-novi-beograd', label: { sr: 'Laser terapija', en: 'Laser therapy', ru: 'Лазер' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Savski venac, Beograd',
        metaTitle: 'Fizikalna terapija Savski venac | PHYSIOWRLD',
        metaDesc: 'PHYSIOWRLD klinika — 12 minuta autom od Savskog venca preko Brankovog mosta. Fizikalna terapija, kiropraktika i HILT laser. Pozovite +381 60 503 7477.',
        intro: 'Za pacijente sa Savskog venca PHYSIOWRLD je dostupan preko Brankovog ili Gazele mosta — oko 12 minuta autom. Najčešći zahtev su tegobe od kancelarijskog rada (vrat, gornji deo leđa, ramena).',
        whyHere: ['Direktan pristup preko Brankovog ili Gazele mosta.', 'Brze procedure za "office" tegobe (kiropraktika, terapeutska masaža).', 'HILT laser bez čekanja.', 'Mogućnost termina pre/posle radnog vremena.'],
        directions: [
          { mode: 'Autom', description: 'Brankov most ili Gazela — 10-12 minuta van špica.' },
          { mode: 'Autobusom', description: 'Linije 16, 17, 18 i 95 idu preko Save do Novog Beograda.' },
          { mode: 'Taksijem / Bolt', description: 'Vožnja se uglavnom računa za 12-15 minuta.' },
        ],
        popularServices: ['Kiropraktika kod cervikalnog sindroma', 'Terapeutska masaža gornjih leđa', 'HILT laser', 'Fizikalna terapija lumbalnog sindroma', 'Skidanje masti AWT'],
        nearby: ['Klinički centar Srbije', 'Hram Svetog Save', 'BIG Senjak', 'Topčiderska zvezda', 'Beograd na vodi'],
        faqs: [
          { question: 'Koliko je vožnja sa Savskog venca?', answer: 'Oko 10-12 minuta autom van špica, preko Brankovog ili Gazele mosta.' },
          { question: 'Da li imate termine van radnog vremena?', answer: 'Da, dostupni su termini pre 9 i posle 17 — pogodno za zaposlene iz centra.' },
          { question: 'Da li radite HILT laser bez čekanja?', answer: 'Najčešće da — pozovite za prvi slobodan termin.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Savski Venac, Belgrade',
        metaTitle: 'Physical Therapy Savski Venac | PHYSIOWRLD',
        metaDesc: 'PHYSIOWRLD clinic — 12 minutes by car from Savski Venac across Brankov Bridge. Physical therapy, chiropractic, HILT laser.',
        intro: 'For Savski Venac patients PHYSIOWRLD is reachable across Brankov or Gazela bridge in about 12 minutes. Most common requests are office-related (neck, upper back, shoulders).',
        whyHere: ['Direct access via Brankov or Gazela bridge.', 'Quick "office worker" protocols.', 'HILT laser with short waiting times.', 'Before/after-hours slots.'],
        directions: [
          { mode: 'By car', description: 'Brankov or Gazela bridge — 10-12 minutes off peak.' },
          { mode: 'By bus', description: 'Lines 16, 17, 18 and 95 cross the Sava to New Belgrade.' },
          { mode: 'Taxi / Bolt', description: 'Usually 12-15 minutes.' },
        ],
        popularServices: ['Chiropractic for cervical syndrome', 'Therapeutic upper-back massage', 'HILT laser', 'Lumbar pain physical therapy', 'AWT fat reduction'],
        nearby: ['Clinical Centre of Serbia', 'St. Sava Temple', 'BIG Senjak', 'Topčider Star', 'Belgrade Waterfront'],
        faqs: [
          { question: 'How long from Savski Venac?', answer: '10-12 minutes by car off peak.' },
          { question: 'Do you have after-hours slots?', answer: 'Yes — before 9 and after 17 — ideal for downtown workers.' },
          { question: 'Is HILT laser available without a long wait?', answer: 'Usually yes — call for the first free slot.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Савски Венац, Белград',
        metaTitle: 'Физиотерапия Савски Венац | PHYSIOWRLD',
        metaDesc: 'PHYSIOWRLD — 12 минут на машине от Савского Венаца через мост Бранкo. Физиотерапия, хиропрактика, HILT-лазер.',
        intro: 'Для пациентов с Савского Венаца PHYSIOWRLD доступен через мосты Бранко или Газела — около 12 минут.',
        whyHere: ['Прямой доступ через мосты.', 'Быстрые протоколы для офисных проблем.', 'HILT-лазер без долгого ожидания.', 'Слоты до/после работы.'],
        directions: [
          { mode: 'На машине', description: 'Мост Бранкo или Газела — 10-12 минут.' },
          { mode: 'Автобусом', description: 'Маршруты 16, 17, 18 и 95.' },
          { mode: 'Такси / Bolt', description: '12-15 минут.' },
        ],
        popularServices: ['Хиропрактика шеи', 'Терапевтический массаж', 'HILT-лазер', 'Физиотерапия поясницы', 'УВТ для жира'],
        nearby: ['Клинический центр Сербии', 'Храм Святого Саввы', 'BIG Senjak', 'Топчидер', 'Beograd na vodi'],
        faqs: [
          { question: 'Сколько ехать?', answer: '10-12 минут.' },
          { question: 'Есть ли слоты после работы?', answer: 'Да.' },
        ],
      },
    },
  },
  // 9. VRAČAR
  {
    slug: 'fizikalna-terapija-vracar',
    name: { sr: 'Vračar', en: 'Vračar', ru: 'Врачар' },
    distanceKm: 5.8,
    walkMinutes: 75,
    driveMinutes: 15,
    relatedDiagnoses: ['bol-u-vratu-tretman-beograd', 'bol-u-ramenu-tretman-beograd', 'karpalni-tunel-tretman-beograd', 'teniski-lakat-tretman-beograd'],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/kiropraktika-novi-beograd', label: { sr: 'Kiropraktika', en: 'Chiropractic', ru: 'Хиропрактика' } },
      { path: '/shockwave-terapija-novi-beograd', label: { sr: 'Shockwave', en: 'Shockwave', ru: 'УВТ' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Vračar, Beograd',
        metaTitle: 'Fizikalna terapija Vračar | PHYSIOWRLD Novi Beograd',
        metaDesc: 'PHYSIOWRLD klinika — 15 minuta autom sa Vračara preko Gazele. Fizikalna terapija, kiropraktika i shockwave. Pozovite +381 60 503 7477.',
        intro: 'Za pacijente sa Vračara PHYSIOWRLD je dostupan autom za oko 15 minuta, preko Gazele. Najčešće dolaze za kiropraktiku, shockwave protokole i terapeutsku masažu kao podrška kancelarijskim profesijama.',
        whyHere: ['Direktan pravac preko Gazele.', 'Kiropraktika za sedeće profesije.', 'Shockwave za hronične tendinopatije.', 'Termini van špica.'],
        directions: [
          { mode: 'Autom', description: 'Gazela ili Brankov most — oko 15 minuta van špica.' },
          { mode: 'Autobusom', description: 'Linije 16, 17 i 78 imaju direktnu vezu Vračar — Novi Beograd.' },
          { mode: 'Taksijem', description: 'Vožnja se uglavnom računa za 15-20 minuta.' },
        ],
        popularServices: ['Kiropraktika cervikalnog dela', 'Shockwave za teniski i golferski lakat', 'HILT laser kod karpalnog tunela', 'Terapeutska masaža', 'Fizikalna terapija ramena'],
        nearby: ['Hram Svetog Save', 'Slavija', 'Crveni krst', 'Kalenić pijaca', 'Tašmajdan'],
        faqs: [
          { question: 'Koliko je vožnja sa Vračara?', answer: 'Oko 15 minuta autom van špica, preko Gazele.' },
          { question: 'Da li lečite teniski lakat?', answer: 'Da, shockwave + ekscentrične vežbe su standardni protokol za lateralni epikondilitis.' },
          { question: 'Ima li parking?', answer: 'Da, ispred ulaza u zgradu.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Vračar, Belgrade',
        metaTitle: 'Physical Therapy Vračar | PHYSIOWRLD New Belgrade',
        metaDesc: 'PHYSIOWRLD clinic — 15 minutes by car from Vračar via Gazela. Physical therapy, chiropractic, shockwave. Call +381 60 503 7477.',
        intro: 'For Vračar patients PHYSIOWRLD is around 15 minutes by car via the Gazela bridge. Most common requests are chiropractic, shockwave protocols and therapeutic massage for desk-bound professions.',
        whyHere: ['Direct via Gazela bridge.', 'Chiropractic for sedentary professions.', 'Shockwave for chronic tendinopathies.', 'Off-peak slots.'],
        directions: [
          { mode: 'By car', description: 'Gazela or Brankov — ~15 minutes off peak.' },
          { mode: 'By bus', description: 'Lines 16, 17 and 78 link Vračar with New Belgrade.' },
          { mode: 'By taxi', description: 'Usually 15-20 minutes.' },
        ],
        popularServices: ['Cervical chiropractic', 'Shockwave for tennis/golf elbow', 'HILT laser for carpal tunnel', 'Therapeutic massage', 'Shoulder physical therapy'],
        nearby: ['St. Sava Temple', 'Slavija', 'Crveni Krst', 'Kalenić Market', 'Tašmajdan'],
        faqs: [
          { question: 'How long from Vračar?', answer: '~15 minutes by car off peak.' },
          { question: 'Do you treat tennis elbow?', answer: 'Yes — shockwave + eccentric exercise is the standard protocol.' },
          { question: 'Parking?', answer: 'Yes, in front of the entrance.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Врачар, Белград',
        metaTitle: 'Физиотерапия Врачар | PHYSIOWRLD Новый Белград',
        metaDesc: 'PHYSIOWRLD — 15 минут на машине от Врачара через Газелу. Физиотерапия, хиропрактика, УВТ.',
        intro: 'Для пациентов с Врачара PHYSIOWRLD доступен за 15 минут через мост Газела.',
        whyHere: ['Прямой проезд через Газелу.', 'Хиропрактика для сидячих профессий.', 'УВТ при хронических тендинопатиях.', 'Слоты вне пика.'],
        directions: [
          { mode: 'На машине', description: '~15 минут.' },
          { mode: 'Автобусом', description: 'Маршруты 16, 17 и 78.' },
          { mode: 'Такси', description: '15-20 минут.' },
        ],
        popularServices: ['Хиропрактика шеи', 'УВТ при эпикондилите', 'HILT-лазер при туннельном синдроме', 'Терапевтический массаж', 'Физиотерапия плеча'],
        nearby: ['Храм Святого Саввы', 'Славия', 'Красный Крест', 'Рынок Каленич', 'Ташмайдан'],
        faqs: [
          { question: 'Сколько ехать?', answer: '~15 минут.' },
          { question: 'Лечите теннисный локоть?', answer: 'Да — УВТ и эксцентрические упражнения.' },
        ],
      },
    },
  },
  // 10. DORĆOL (Stari grad)
  {
    slug: 'fizikalna-terapija-dorcol',
    name: { sr: 'Dorćol', en: 'Dorćol', ru: 'Дорчол' },
    distanceKm: 6.5,
    walkMinutes: 85,
    driveMinutes: 18,
    relatedDiagnoses: ['bol-u-ledjima-tretman-beograd', 'bol-u-ramenu-tretman-beograd', 'isijas-tretman-beograd', 'bol-u-kuku-tretman-beograd'],
    relatedServices: [
      { path: '/fizikalna-terapija-novi-beograd', label: { sr: 'Fizikalna terapija', en: 'Physical therapy', ru: 'Физиотерапия' } },
      { path: '/shockwave-terapija-novi-beograd', label: { sr: 'Shockwave', en: 'Shockwave', ru: 'УВТ' } },
      { path: '/masaza-novi-beograd', label: { sr: 'Terapeutska masaža', en: 'Therapeutic massage', ru: 'Терапевтический массаж' } },
    ],
    i18n: {
      sr: {
        h1: 'Fizikalna terapija — Dorćol, Beograd',
        metaTitle: 'Fizikalna terapija Dorćol | PHYSIOWRLD',
        metaDesc: 'PHYSIOWRLD klinika — 18 minuta autom sa Dorćola preko Brankovog mosta. Fizikalna terapija, shockwave i terapeutska masaža.',
        intro: 'Stanovnici Dorćola dolaze nam preko Brankovog mosta za oko 18 minuta. Najčešći zahtevi su tretman bola u leđima, ramenu i postoperativna rehabilitacija.',
        whyHere: ['Direktan pravac preko Brankovog mosta.', 'Shockwave i HILT laser bez čekanja.', 'Termini posle 18h za zaposlene iz centra.', 'Parking ispred zgrade.'],
        directions: [
          { mode: 'Autom', description: 'Brankov most + Bulevar Mihaila Pupina — oko 18 minuta.' },
          { mode: 'Autobusom', description: 'Linija 95 i 16 imaju direktnu vezu sa Novim Beogradom.' },
          { mode: 'Taksijem', description: 'Najpouzdaniji prevoz — oko 15-20 minuta.' },
        ],
        popularServices: ['Fizikalna terapija lumbalnog sindroma', 'Shockwave za hronične bolove', 'Terapeutska masaža', 'Kiropraktika', 'Postoperativna rehabilitacija'],
        nearby: ['Kalemegdan', 'Skadarlija', 'Bajloni pijaca', 'Beton hala', 'Studentski park'],
        faqs: [
          { question: 'Koliko je vožnja sa Dorćola?', answer: 'Oko 18 minuta autom preko Brankovog mosta van špica.' },
          { question: 'Da li mogu doći posle posla?', answer: 'Da, termini posle 18 sata su redovno dostupni.' },
          { question: 'Da li imate parking?', answer: 'Da, parking je ispred ulaza u zgradu.' },
        ],
      },
      en: {
        h1: 'Physical therapy — Dorćol, Belgrade',
        metaTitle: 'Physical Therapy Dorćol | PHYSIOWRLD',
        metaDesc: 'PHYSIOWRLD clinic — 18 minutes by car from Dorćol via Brankov bridge. Physical therapy, shockwave, therapeutic massage.',
        intro: 'Dorćol residents reach us via Brankov bridge in about 18 minutes. Most common requests are back and shoulder pain treatment and post-operative rehabilitation.',
        whyHere: ['Direct via Brankov bridge.', 'Shockwave and HILT laser without long waits.', 'After-18h slots for downtown workers.', 'Parking at the entrance.'],
        directions: [
          { mode: 'By car', description: 'Brankov bridge + Mihaila Pupina Boulevard — ~18 minutes.' },
          { mode: 'By bus', description: 'Lines 95 and 16 link Dorćol with New Belgrade.' },
          { mode: 'By taxi', description: 'Most reliable — 15-20 minutes.' },
        ],
        popularServices: ['Lumbar physical therapy', 'Shockwave for chronic pain', 'Therapeutic massage', 'Chiropractic', 'Post-operative rehabilitation'],
        nearby: ['Kalemegdan', 'Skadarlija', 'Bajloni Market', 'Beton Hala', 'Students Park'],
        faqs: [
          { question: 'How long from Dorćol?', answer: '~18 minutes by car off peak.' },
          { question: 'Can I come after work?', answer: 'Yes, slots after 18:00 are routinely available.' },
          { question: 'Parking?', answer: 'Yes, in front of the entrance.' },
        ],
      },
      ru: {
        h1: 'Физиотерапия — Дорчол, Белград',
        metaTitle: 'Физиотерапия Дорчол | PHYSIOWRLD',
        metaDesc: 'PHYSIOWRLD — 18 минут на машине от Дорчола через мост Бранкo. Физиотерапия, УВТ и терапевтический массаж.',
        intro: 'Из Дорчола до нас 18 минут через мост Бранкo. Чаще обращаются за лечением боли в спине и плече, послеоперационной реабилитацией.',
        whyHere: ['Прямой проезд через мост Бранкo.', 'УВТ и HILT-лазер без ожидания.', 'Слоты после 18:00.', 'Парковка у входа.'],
        directions: [
          { mode: 'На машине', description: '~18 минут.' },
          { mode: 'Автобусом', description: 'Маршруты 95 и 16.' },
          { mode: 'Такси', description: '15-20 минут.' },
        ],
        popularServices: ['Физиотерапия поясницы', 'УВТ при хронической боли', 'Терапевтический массаж', 'Хиропрактика', 'Послеоперационная реабилитация'],
        nearby: ['Калемегдан', 'Скадарлия', 'Рынок Байлони', 'Beton Hala', 'Студенческий парк'],
        faqs: [
          { question: 'Сколько ехать?', answer: '~18 минут.' },
          { question: 'Принимаете вечером?', answer: 'Да, после 18:00.' },
        ],
      },
    },
  },
];

export const LOCATION_MAP = Object.fromEntries(LOCATIONS.map((l) => [l.slug, l]));
